<template>
    <v-container fluid class='mb-10'>

        <v-row>

            <v-col cols='3'>
                <div class="pointer-events">
                    <v-img class="logo" contain src="../../../assets/logo-patente.png"></v-img>
                </div>
            </v-col>

            <v-col cols='3'>

                <div class=' body-2 text-uppercase link-footer-about'><a href="https://provedor.querointernet.net/" target="_blank">{{$t('about')}}</a></div>
                <div class=' body-2 text-uppercase link-footer-features'><a href="https://provedor.querointernet.net/" target="_blank">{{$t('features')}}</a></div>
                <div class=' body-2 text-uppercase link-footer-faq'><a href="https://provedor.querointernet.net/" target="_blank">{{$t('faq')}}</a></div>
                <div class=' body-2 text-uppercase link-footer-contact'><a href="https://provedor.querointernet.net/" target="_blank">{{$t('contact')}}</a></div>

            </v-col>
            <v-col cols='2'>
                <div class="pointer-events">
                    <v-img class="logo" contain src="../../../assets/certified.png"></v-img>
                </div>
            </v-col>
            <v-col cols='4'>
                <v-btn @click="openLinks('https://www.facebook.com/querointernet.net/')" class="mx-1 btn-footer-face" fab outlined color="#4ec5c1">
                    <v-icon>mdi-facebook</v-icon>
                </v-btn>
                <v-btn @click="openLinks('https://www.facebook.com/querointernet.net/')" class="mx-1 btn-footer-youtube" fab outlined color="primary">
                    <v-icon>mdi-youtube</v-icon>
                </v-btn>
                <v-btn @click="openLinks('https://www.linkedin.com/in/querointernetbr/?originalSubdomain=br')" class="mx-1 btn-footer-linkedin" fab outlined color="#4ec5c1">
                    <v-icon>mdi-linkedin</v-icon>
                </v-btn>
                <v-btn @click="openLinks('https://www.instagram.com/querointernetbr/')" class="mx-1 btn-footer-ig" fab outlined color="primary">
                    <v-icon>mdi-instagram</v-icon>
                </v-btn>
                <v-btn @click="openLinks('https://twitter.com/querointernetbr')" class="mx-1 btn-footer-tt" fab outlined color="#4ec5c1">
                    <v-icon>mdi-twitter</v-icon>
                </v-btn>
            </v-col>

        </v-row>

    </v-container>
</template>

<script>
export default {
    name: 'FooterContainer',

    methods: {
        openLinks(link) {

            window.open(link, '_blank')

        }
    },

}
</script>
<style scoped>



</style>